import { GhostButton, Modal } from '@mgh-app/component-library';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { display, gridTemplateRows, justifyItems, margin, twCls } from 'style';

export interface PopupDialogProps {
  open?: boolean;
  type: 'Information' | 'Error';
  message: string;
  dismissAction: () => void | undefined;
}

export const PopupDialog = ({
  open = true,
  type,
  message,
  dismissAction,
}: PopupDialogProps): JSX.Element => {
  return (
    <div
      className={twCls(
        display('grid'),
        gridTemplateRows('grid-rows-min-content-5'),
        justifyItems('justify-items-center'),
        margin('mt-6'),
      )}
    >
      <Modal open={open}>
        <DialogTitle>{type}</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <GhostButton onClick={dismissAction}>Dismiss</GhostButton>
        </DialogActions>
      </Modal>
    </div>
  );
};
